export default class FilterRequests {
    get(url, query) {
        return $.ajax({
            url: url,
            method: 'GET',
            data: query
        });
    };

    post(url, data) {
        return $.ajax({
            url: url,
            method: 'POST',
            data: data
        });
    };

    encode(vars) {
        let list = [];
        $.each(vars, function(index, value) {
            if (Array.isArray(value)) {
                list.push(index + '*:' + value.join(','));
            } else {
                list.push(index + ':' + value);
            }
        });
        return list.join(';');
    };

    decode(str) {
        let list = str.split(';');
        let res = {};
        $.each(list, function(_, val) {
            let kv = val.split(':');
            let name = kv[0];
            let value = kv[1];
            if (name.substr(-1) === '*') {
                name = name.substr(0, name.length - 1);
                value = value.length ? value.split(',') : [];
            }
            res[name] = value;
        });
        return res;
    };

    preloader(status, resetAll) {
        let $owP = $('.overlay_page');
        if(status === true) {
            $owP.prepend('<img style="position: absolute;left: 50%;top:50%;transform: translate(-50%, -50%)" src="/assets/images/svg/preloader.svg">');
            $owP.fadeIn(200);
        } else {
            if($(window).width() >= 1200 || this.sortFlag) {
                $owP.fadeOut(200, function () {
                    $owP.find('img').remove();
                });
                this.sortFlag = false;
            } else {
                $owP.find('img').remove();
                if(resetAll) {
                    $owP.trigger('click');
                }
            }
        }
    }

    scrollToTop() {
        $('html, body').stop().animate({
            'scrollTop': 0
        }, 400, 'swing')
    }
}
